var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarePackages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18340",
    transform: "translate(-1326 -462)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 172",
    width: 65,
    height: 65,
    rx: 32.5,
    transform: "translate(1326 462)",
    style: {
      fill: "#ea5d6e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 32",
    d: "M61.17 164.268a.849.849 0 0 1-.6-.25l-10.8-10.8a.853.853 0 0 1 1.206-1.206L61.17 162.21l10.192-10.192a.853.853 0 1 1 1.206 1.206l-10.8 10.8a.85.85 0 0 1-.598.244z",
    transform: "translate(1297.017 346.563)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33",
    d: "M17.6 99.142h-.036a.851.851 0 0 1-.756-.537l-4.123-10.359-2.572 5.49a.853.853 0 0 1-.772.491H.853a.853.853 0 0 1 0-1.706H8.8l3.178-6.784a.865.865 0 0 1 .8-.49.853.853 0 0 1 .767.537l4.146 10.421 3.8-7.6a.852.852 0 0 1 .763-.471.852.852 0 0 1 .762.476l1.928 3.915h12.577a.853.853 0 1 1 0 1.705H24.415a.852.852 0 0 1-.765-.476l-1.4-2.85-3.885 7.77a.853.853 0 0 1-.765.468z",
    transform: "translate(1339 402.958)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34",
    d: "M2.44 34.056a.851.851 0 0 1-.705-.372 9.9 9.9 0 0 1 15.181-12.572L19.2 23.4l2.285-2.285a9.9 9.9 0 0 1 15.182 12.569.853.853 0 0 1-1.409-.961 8.193 8.193 0 0 0-12.567-10.4L19.8 25.206a.878.878 0 0 1-1.206 0l-2.887-2.888a8.194 8.194 0 0 0-12.567 10.4.853.853 0 0 1-.7 1.333z",
    transform: "translate(1338.986 459.783)",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarePackages);
export default __webpack_public_path__ + "static/media/care-packages.935f0f5bb746e13ce8cd2e8e5b2e164f.svg";
export { ForwardRef as ReactComponent };